import type { AudioAdapter, SoundEffect } from '../interfaces/audio.js';

const EFFECT_FREQUENCIES: Record<SoundEffect, number> = {
  'tile-play': 420,
  'trick-win': 660,
  'bid-pass': 280,
  'ui-tap': 360,
};

export function createWebAudioAdapter(): AudioAdapter {
  let enabled = true;
  let audioContext: globalThis.AudioContext | null = null;

  function context(): globalThis.AudioContext | null {
    if (typeof window === 'undefined') return null;
    if (!audioContext) {
      const AudioCtor =
        window.AudioContext ??
        (window as typeof window & { webkitAudioContext?: typeof globalThis.AudioContext })
          .webkitAudioContext;
      if (!AudioCtor) return null;
      audioContext = new AudioCtor();
    }
    return audioContext;
  }

  return {
    get enabled() {
      return enabled;
    },

    setEnabled(next: boolean) {
      enabled = next;
    },

    play(effect: SoundEffect) {
      if (!enabled) return;
      const ctx = context();
      if (!ctx) return;

      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();
      oscillator.type = 'sine';
      oscillator.frequency.value = EFFECT_FREQUENCIES[effect];
      gain.gain.value = 0.0001;
      oscillator.connect(gain);
      gain.connect(ctx.destination);

      const now = ctx.currentTime;
      gain.gain.exponentialRampToValueAtTime(0.05, now + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.12);
      oscillator.start(now);
      oscillator.stop(now + 0.14);

      void ctx.resume();
    },
  };
}
